// extracted by mini-css-extract-plugin
export default {"pageWrapper":"text_pageWrapper__t25if","blockWrapper":"text_blockWrapper__hi6cL","title":"text_title__Dcycs"};